import React from 'react';
import PropTypes from 'prop-types';
import getBundleUrl from 'js/manifest';

import { BASENAME } from 'js/constants';

const PDFJSPromise = import('pdfjs-dist');

export default class PdfContext extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pdf: null,
    };
  }

  getChildContext = () => {
    const { scale } = this.props;
    const { pdf } = this.state;

    return { pdf, scale };
  };

  componentDidMount = () => {
    this.getDocument();
  };

  componentDidUpdate = prevProps => {
    const { file } = this.props;

    if (prevProps.file && prevProps.file.getId() !== file.getId()) {
      this.getDocument();
    }
  };

  getDocument = () => {
    const { file } = this.props;
    const docUrl = BASENAME + '/api/documents/' + file.getId() + '/contents/' + file.page;
    const pdfWorkerUrl = 'build/main/js/pdf.worker.bundle.js';

    Promise.all([PDFJSPromise, getBundleUrl(pdfWorkerUrl)])
      .then(([pdfJs, workerSrc]) => {
        const { PDFJS } = pdfJs;
        PDFJS.workerSrc = workerSrc;
        return pdfJs.getDocument(docUrl);
      })
      .then(pdf => this.setState({ pdf }));
  };

  render() {
    return <div class="pdf-context">{this.props.children}</div>;
  }
}
PdfContext.defaultProps = {
  scale: 0.8,
};
PdfContext.propTypes = {
  // src: PropTypes.string.isRequired
};
PdfContext.childContextTypes = {
  pdf: PropTypes.object,
  scale: PropTypes.number,
};
